import { api } from "./api"

export const GET_ALL_ROUTES = async () => {
    const {data} = await api.get(`/routes/all`)
    return data;
}

export const DELETE_ROUTE = async (agencyId) => {
    const {data} = await api.delete(`/routes/${agencyId}`)
    return data;
}

export const SAVE_ROUTE = async (params) => {
    const {data} = await api.post(`/routes/save`, params)
    return data;
}

export const SAVE_ROUTE_SHAPES = async (routeId, direction, params) => {
    const {data} = await api.post(`/routes/${routeId}/shapes/${direction}`, params)
    return data;
}

export const SAVE_ROUTE_TRIPS = async (routeId, params) => {
    const {data} = await api.post(`/routes/${routeId}/trips`, params)
    return data;
}

export const SAVE_ROUTE_EXCEPTION = async (routeId, params) => {
    const {data} = await api.post(`/routes/${routeId}/exceptions`, params)
    return data;
}

export const SAVE_TRAVEL = async (params) => {
    const {data} = await api.post(`/routes/travels`, params)
    return data;
}
